<template>
    <div id="modal-three-dee" class="uk-flex-top" uk-modal>
        <div class="uk-modal-dialog uk-width-auto uk-margin-auto-vertical">
            <button class="uk-modal-close-outside" type="button" uk-close></button>
            <!-- 1600x1067 = 999x666 = 900x600 = 3x2 -->
            <!-- 1600x800 = 900x450 = 2x1 -->
            <iframe id="modal-three-dee-iframe" width="999" height="666" frameborder="0" uk-responsive></iframe>
        </div>
    </div>
</template>
